// Clima de Asunción a partir del METAR del aeropuerto Silvio Pettirossi (SGAS).
//
// Por qué el METAR: es una observación real (no un pronóstico), pública, sin cuenta ni
// clave, de dominio público (servicio de NOAA, aviationweather.gov). Si en Asunción
// llueve de verdad, el METAR lo dice; eso es lo que pide el easter egg de la lluvia.

export type WeatherKind = "despejado" | "nublado" | "llovizna" | "lluvia" | "tormenta";

export type WeatherNow = { ok: true; tempC: number; label: WeatherKind; observed: string } | { ok: false };

type Metar = {
  temp?: number;
  wxString?: string;
  cover?: string;
  clouds?: { cover?: string }[];
  reportTime?: string;
};

export function classify(m: Metar): WeatherKind {
  const wx = (m.wxString ?? "").toUpperCase();
  if (/TS/.test(wx)) return "tormenta";
  if (/(^|\s|[+-])(SH)?RA/.test(wx) && !/DZ/.test(wx)) return "lluvia";
  if (/DZ/.test(wx)) return "llovizna";
  const covers = [m.cover, ...(m.clouds ?? []).map((c) => c.cover)].filter(Boolean).map((c) => String(c).toUpperCase());
  if (covers.some((c) => c === "BKN" || c === "OVC" || c === "OVX")) return "nublado";
  return "despejado";
}

/** Intensidad de lluvia para la escena (worldBus.rain): 0 seco, 1 llovizna, 2 lluvia, 3 tormenta. */
export function rainLevel(label: string | null | undefined): 0 | 1 | 2 | 3 {
  if (label === "tormenta") return 3;
  if (label === "lluvia") return 2;
  if (label === "llovizna") return 1;
  return 0;
}

export function parseMetar(json: unknown): WeatherNow {
  const m = Array.isArray(json) ? (json[0] as Metar | undefined) : undefined;
  if (!m || typeof m.temp !== "number" || !Number.isFinite(m.temp)) return { ok: false };
  return { ok: true, tempC: Math.round(m.temp), label: classify(m), observed: m.reportTime ?? "" };
}
